import { render, staticRenderFns } from "./productInfo__list.vue?vue&type=template&id=0d1a13a3"
import script from "./productInfo__list.vue?vue&type=script&lang=js"
export * from "./productInfo__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports